import axios from "axios";

export default {
  methods: {
    async searchNameMasterList(table, column, name, id_column, field) {
      let url = `/master/search-name-list?id_column=${id_column}&table=${table}&column=${column}`
      if(name) {
        url += `&name=${name}`
      }
      if(field) {
        url += `&field=${field}`
      }
      return await axios({
        method: "GET",
        url: url
      })
    },
    async makeRequest(method, url, payload = {}) {
      return await axios({
        method: method,
        url,
        data: payload
      })
    },
  }
}